import React from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { DownloadSimple, FileXls, FilePdf } from "@phosphor-icons/react";

export default function ExportButtons({ onExcel, onPDF }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" data-testid="export-btn" className="border-slate-300 text-slate-600">
          <DownloadSimple size={16} className="mr-1.5" /> Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onExcel} data-testid="export-excel" className="gap-2">
          <FileXls size={16} className="text-emerald-600" /> Export Excel
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onPDF} data-testid="export-pdf" className="gap-2">
          <FilePdf size={16} className="text-red-600" /> Export PDF
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
